require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.object.assign");

!function (t, n) {
  "object" == typeof exports && "undefined" != typeof module ? n(exports, require("react")) : "function" == typeof define && define.amd ? define(["exports", "react"], n) : n((t = t || self).reactHooksGlobalState = {}, t.react);
}(this, function (t, n) {
  function e() {
    return (e = Object.assign || function (t) {
      for (var n = 1; n < arguments.length; n++) {
        var e = arguments[n];

        for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
        }
      }

      return t;
    }).apply(this, arguments);
  }

  var r = function r(t, n) {
    if (!t.includes(n)) throw new Error("'" + n + "' not found. It must be provided in initialState as a property key.");
  },
      o = "production" !== process.env.NODE_ENV ? Symbol("UPDATE_STATE") : Symbol(),
      u = function u(t, _u) {
    var i = Object.keys(_u),
        c = _u,
        f = null,
        a = {};
    i.forEach(function (t) {
      a[t] = new Set();
    });

    var s = function s(n, e) {
      return e.type === o ? e.r ? e.r(n) : e.e : t(n, e);
    },
        l = function l(t, n) {
      "production" !== process.env.NODE_ENV && r(i, t);

      var u = function u(r) {
        var o, u;
        return e({}, r, ((o = {})[t] = "function" == typeof (u = n) ? u(r[t]) : u, o));
      };

      if (f) {
        var s;
        f(((s = {
          type: o
        }).r = u, s));
      } else {
        var l = (c = u(c))[t];
        a[t].forEach(function (t) {
          return t(l);
        });
      }
    },
        d = function d(t, n) {
      i.forEach(function (e) {
        var r = n[e];
        t[e] !== r && a[e].forEach(function (t) {
          return t(r);
        });
      });
    };

    return {
      useGlobalStateProvider: function useGlobalStateProvider() {
        var t = n.useReducer(s, c),
            e = t[0],
            r = t[1];
        n.useEffect(function () {
          var t;
          if (f) throw new Error("Only one global state provider is allowed");
          return f = r, r(((t = {
            type: o
          }).e = c, t)), function () {
            f = null;
          };
        }, []);
        var u = n.useRef(e);
        d(u.current, e), u.current = e, n.useEffect(function () {
          c = e;
        }, [e]);
      },
      useGlobalState: function useGlobalState(t) {
        "production" !== process.env.NODE_ENV && r(i, t);
        var e = n.useState(c[t]),
            o = e[0],
            u = e[1];
        return n.useEffect(function () {
          return a[t].add(u), u(c[t]), function () {
            a[t]["delete"](u);
          };
        }, [t]), [o, n.useCallback(function (n) {
          return l(t, n);
        }, [t])];
      },
      getGlobalState: function getGlobalState(t) {
        return "production" !== process.env.NODE_ENV && r(i, t), c[t];
      },
      setGlobalState: l,
      getState: function getState() {
        return c;
      },
      setState: function setState(t) {
        var n;
        f ? f(((n = {
          type: o
        }).e = t, n)) : d(c, c = t);
      },
      dispatch: function dispatch(n) {
        if (f) f(n);else {
          var e = c;
          c = t(c, n), d(e, c);
        }
        return n;
      }
    };
  };

  t.createGlobalState = function (t) {
    return u(function (t, n) {
      return t;
    }, t);
  }, t.createStore = function t(n, e, r) {
    return void 0 === e && (e = n(void 0, {
      type: void 0
    })), r ? r(t)(n, e) : u(n, e);
  }, t.reduxDevToolsExt = function () {
    return window.__REDUX_DEVTOOLS_EXTENSION__ ? function () {
      for (var t = arguments.length, n = new Array(t), e = 0; e < t; e++) {
        n[e] = arguments[e];
      }

      return n.reduce(function (t, n) {
        return function () {
          return t(n.apply(void 0, arguments));
        };
      });
    }(function (r) {
      return function (o, u, i) {
        if (t = o, n = u, i) return i(r)(o, u);
        var c = r(o, u);
        return e({}, c, {
          useGlobalState: function useGlobalState(t) {
            return [c.useGlobalState(t)[0], function () {
              throw new Error("Update is not allowed when using DevTools");
            }];
          }
        });
      };
    }, window.__REDUX_DEVTOOLS_EXTENSION__(), function (r) {
      return function (o, u, i) {
        if (i) return i(r)(o, u);
        var c = r(t, n),
            f = e({}, o(u, {
          type: "@@redux/INIT"
        }), {}, n),
            a = [];
        return e({}, c, {
          getState: function getState() {
            return f;
          },
          dispatch: function dispatch(t) {
            return f = o(f, t), c.setState(f.computedStates[f.currentStateIndex].state), a.forEach(function (t) {
              return t();
            }), t;
          },
          subscribe: function subscribe(t) {
            return a.push(t), function () {
              var n = a.indexOf(t);
              a.splice(n, 1);
            };
          }
        });
      };
    }) : function (t) {
      return t;
    };
    var t, n;
  };
});